import Abstract from '../../framework/Abstract';

import './B8.1-content-teaser.scss';

class B8ContentTeaser extends Abstract {
	init() {
		this.setupObjectFit();
	}
}

export default B8ContentTeaser;
